export class EditorComponentContract {
  constructor(Variations) {
    this.Variations = Variations
    this.variationsData = this.buildVariations(Variations)
    this.pageComponent = false
    this.innerComponent = true
  }

  elementHtml(elementIds, elementClasses = {}, elementContent = {}, elementAssets = []) {
    return (new this.htmlBuilder(elementIds, elementClasses, elementContent, elementAssets)).build()
  }

  buildVariations(Variations) {
    return Object.keys(Variations).map(variation => new Variations[variation])
  }

  variationsInfo() {
    return this.variationsData.map(variation => variation.buildData())
  }

  create(variation) {
    return this.factory.createVariation((new this.Variations[variation]).editorProperties())
  }
}